import React, { Fragment } from 'react';
import { ToastContainer } from 'react-toastify';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { connect } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
// import Routes from './routes';
import './App.css';
import { fetchAuthUser as _fetchAuthUser } from './actions/authUserActions';
import { fetchAdvertisements as _fetchAdvertisements } from './actions/advertisementActions';
import { setAppService as _setAppService } from './actions/appActions';
import CBSpinner from './components/shared/CBSpinner';
import {
  Route,
  Switch
} from 'react-router';
import HomeEndUser from './components/HomeView/HomeEndUser';
import HomeWSUser from './components/HomeView/HomeWSUser';
import GarageLayoutView from './components/GarageView/GarageLayoutView';
import MainLayoutView from './components/MainLayoutView';
import MainHeaderBar from './components/Header/MainHeaderBar';
import Footer from './components/Footer/Footer';
import VehicleDetailsView from './components/VehicleDetailsView/VehicleDetailsView';
import WSVehicleDetailsView from './components/WSVehicleDetailsView/WSVehicleDetailsView';
import UserSettingsView from './components/SettingsView/UserSettingsView';
import StaffStatsView from './components/StaffStatsView/StaffStatsView';
import AdvertisementsView from './components/AdvertisementsView/AdvertisementsView';
import i18n from './i18n';
import AnnouncementView from './components/AnnouncementView/AnnouncementView';
import WSSettingsView from './components/WSSettingsView/WSSettingsView';
import OrganizationGarageLayoutView from './components/OrganizationGarageView/OrganizationGarageLayoutView';
import PaymentResultView from './components/PaymentsView/PaymentResultView';
import FleetLocationView from './components/FleetLocationView/FleetLocationView';
import FleetLocationPage from './components/FleetLocationView/FleetLocationPage';
import AdvertisementEditorView from './components/AdvertisementsView/AdvertisementEditorView';
import HomeWorkshopUser from './components/HomeView/HomeWorkshopUser';
import { SERVICE_ADMIN, SERVICE_FLEET, SERVICE_PERSONAL, SERVICE_WORKSHOP, SERVICE_CHAIN } from './utils/utils';
import HomeAdminUser from './components/HomeView/HomeAdminUser';
import SaleReportView from './components/SaleReportView/SaleReportView';
import DemoPanel from './components/DemoPanel/DemoPanel';
import ChainHomeView from './components/ChainView/ChainHomeView';
import ChainSettingsViewV2 from './components/ChainView/ChainSettingsViewV2';
import { startUsageEvents } from './utils/usageEvents';


export class App extends React.Component {
  componentWillMount = () => {
    const { fetchAuthUser, fetchAdvertisements, history } = this.props;
    fetchAuthUser();
    fetchAdvertisements();
    startUsageEvents(history, this.setAppService(true));
  };

  setAppService = () => {
    const { setAppService } = this.props;
    const url = window.location.href;
    let service = SERVICE_PERSONAL;

    if (url.includes('service.')) {
      service = SERVICE_WORKSHOP;
    } else if (url.includes('fleet.')) {
      service = SERVICE_FLEET;
    } else if (url.includes('admin.')) {
      service = SERVICE_ADMIN;
    } else if (url.includes('chain.')) {
      service = SERVICE_CHAIN;
    }

    setAppService(service);

    return service;
  };

  render() {
    console.log('Ovio Carbook Oy, 2025/1');
    const { authUserRequest, history, service } = this.props;
    const { user, userStatus } = authUserRequest;

    // THE SLICE CAN BE ABSENT, and this is the first line of the application (OVIO-7).
    // Reading through it threw, React unmounted the whole tree, and the person saw a WHITE
    // PAGE — then reported "the site is broken", which carries no further detail. Reached
    // through the ordinary new-user path: an account still carrying force_password_change is
    // routed to the change-password screen before the auth-user request resolves.
    //
    // Absent is treated as not-yet-known, which is what the next branch already does for
    // `loading`. Both answers were a spinner before this guard, so the change is the crash.
    if (!userStatus || userStatus.error) {
      return <CBSpinner />;
    } else if (userStatus.loading || !user) {
      return <CBSpinner />;
    } else {
      const isStaff = user.is_staff;
      return (
        <I18nextProvider i18n={i18n}>
          <ConnectedRouter history={history}>
            <div>
              <MainHeaderBar isStaff={isStaff} />
              <ToastContainer />
              <MainLayoutView>
                <Switch>
                  <Route
                    exact
                    path='/'
                    component={(routeProps) => {
                      if (service === SERVICE_WORKSHOP) {
                        return <HomeWorkshopUser {...routeProps} {...this.props} />;
                      } else if (isStaff && service === SERVICE_ADMIN) {
                        return <HomeAdminUser {...routeProps} {...this.props} />;
                      } else if (service === SERVICE_PERSONAL) {
                        return <HomeEndUser {...routeProps} {...this.props} />;
                      } else if (service === SERVICE_FLEET) {
                        return <OrganizationGarageLayoutView {...routeProps} {...this.props} />;
                      } else if (service === SERVICE_CHAIN) {
                        return <ChainHomeView {...routeProps} {...this.props} />;
                      }
                      return <div />;
                    }}
                  />
                  {user.is_demo && isStaff && (
                    <Route path='/demo-tools' component={DemoPanel} />
                  )}
                  {isStaff && <Route path='/staff_settings' render={props => <UserSettingsView {...props} staff />} />}
                  {
                    service === SERVICE_WORKSHOP && (
                      <Fragment>
                        <Route path='/workshop/:workshopId/' component={HomeWorkshopUser} />
                        <Route path='/workshop-settings' component={WSSettingsView} />
                        <Route path='/workshop-vehicle/:vehicleId' component={WSVehicleDetailsView} />
                        <Route path='/announcements' component={AnnouncementView} />
                        <Route path='/vehicle/:vehicleId' component={VehicleDetailsView} />
                        <Route path='/payment_result/:orderId?' component={PaymentResultView} />
                      </Fragment>
                    )
                  }

                  {
                    isStaff && service === SERVICE_ADMIN && (
                      <Fragment>
                        <Route path='/workshop-vehicle/:vehicleId' component={WSVehicleDetailsView} />
                        <Route path='/announcements' component={AnnouncementView} />
                        <Route path='/workshop-settings' component={WSSettingsView} />
                        <Route path='/sale-report' component={SaleReportView} />
                      </Fragment>
                    )
                  }
                  {
                    (service === SERVICE_PERSONAL || service === SERVICE_FLEET) && (
                      <Fragment>
                        <Route path='/garage' component={GarageLayoutView} />
                        <Route path='/vehicle/:vehicleId' component={VehicleDetailsView} />
                        <Route path='/settings' component={UserSettingsView} />
                        <Route path='/organization_garage/:organizationId' component={OrganizationGarageLayoutView} />
                        <Route path='/payment_result/:orderId?' component={PaymentResultView} />
                        {/*
                          Vehicle Location POC (VLOC). Standalone and deliberately NOT linked
                          from any navigation: reachable only by typing the URL. The component
                          asks the backend whether the feature is on
                          (/uiapi/1/fleetlocation/config/) and renders a disabled notice if it
                          is not, so mounting the route costs nothing while the flag is off.
                        */}
                        <Route path='/fleet-location/:vehicleId' component={FleetLocationView} />
                        {/* The fleet screen: every permitted vehicle on one map, with
                            the credentials that make it work on the same page. Listed
                            AFTER the single-vehicle route so the more specific path
                            still wins. */}
                        <Route path='/fleet-map' component={FleetLocationPage} />
                      </Fragment>
                    )
                  }

                  {
                    service === SERVICE_CHAIN && (
                      <Fragment>
                        <Route path='/chain/:chainId/' component={ChainHomeView} />
                        <Route path='/chain-settings' component={ChainSettingsViewV2} />
                        <Route path='/vehicle/:vehicleId' component={VehicleDetailsView} />
                        <Route path='/payment_result/:orderId?' component={PaymentResultView} />
                      </Fragment>
                    )
                  }

                </Switch>
                <Route exact path='/' component={Footer} />
                <Route path='/workshop' component={Footer} />
                <Route path='/garage' component={Footer} />
                <Route path='/vehicle' component={Footer} />
                <Route path='/workshop-vehicle' component={Footer} />
                <Route path='/announcements' component={Footer} />
                <Route path='/organization_garage' component={Footer} />
                <Route path='/payment_result' component={Footer} />
                <Route path='/chain' component={Footer} />
                <Route path='/chain-vehicle' component={Footer} />
              </MainLayoutView>
            </div>
          </ConnectedRouter>
        </I18nextProvider>
      );
    }
  }
}

App.propTypes = {
  history: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    authUserRequest: state.authUser,
    service: state.app.service,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchAuthUser: _fetchAuthUser,
    fetchAdvertisements: _fetchAdvertisements,
    setAppService: _setAppService,
  },
)(App);
